export default class Contract {
  public complete = false;

  public sendContactData = false;

  // 連絡先登録
  public lastName = '';

  public firstName = '';

  public lastKana = '';

  public firstKana = '';

  // 携帯電話番号
  public phoneNumber = '';

  public mobileNumber = ''

  public email = '';

  public question1Answer = '';

  public question1Sub1Answer: string[] = [];

  public question1Sub2Answer: string[] = [];

  public question2Answer = '';

  public question3Answer: string[] = [];

  public question4Answer: string[] = [];

  public question5Answer = '';

  // お客様情報(1/2)
  public gender: number | null = null;

  public year: number | null = null;

  public month: number | null = null;

  public day: number | null = null;

  public postalCode = '';

  public address1 = '';

  public address3 = '';

  public addressKana = '';

  public prefectures = '';

  public city = '';

  public street = '';

  public isSameAddress: number | null = null;

  public addressPostalCode = '';

  public addressAddress1 = '';

  public addressAddress3 = '';

  public residenceAddressKana = '';

  public residencePrefectures = '';

  public residenceCity = '';

  public residenceStreet = '';

  public residenceYear = '';

  // 居住形態
  public residenceStatus: number | string = '';

  // 名義人氏名
  public holder = '';

  public maritalStatus: number | null = null;

  public livingPersons: number | string = '';

  public livingMinors: number | string = '';

  // お客様情報(2/2)
  // お勤め先情報
  public businessType: number | null = null;

  // 業種（大分類）
  public industryType = '';

  // 業種（小分類）
  public subIndustryType = '';

  // 勤続年数（年）
  public businessYears: number | null = null;

  // 年収
  public income: number | null = null;

  // 雇用形態
  public position = '';

  // お勤め先情報
  // お勤め先（会社名・屋号）
  public company = '';

  // 現住所とお勤め先住所が同じ
  public businessAddressType: number | null = null;

  // お勤め先郵便番号
  public companyPostalCode = '';

  // お勤め先都道府県市区町村
  public companyAddress1 = '';

  // お勤め先番地以降
  public companyAddress3 = '';

  // お勤め先お電話番号
  public companyPhoneNumber = '';

  public officeAddressKana = '';

  public officePrefectures = '';

  public officeCity = '';

  public officeStreet = '';

  // 免許証番号
  public licenseNumber = '';

  // 隠しパラメータ
  public cvSource?: string;

  public utmSource = '';

  public utmMedium = '';

  public utmCampaign = '';

  public previousUrl = '';

  public lineId = '';

  // 申込みID
  public reservationId = '';
}
